module.exports = __webpack_public_path__ + "static/media/SFX_Button_Click_2.ca766b8d.mp3";